import { render, staticRenderFns } from "./ChatCommentAttachment.vue?vue&type=template&id=14039e54"
import script from "./ChatCommentAttachment.vue?vue&type=script&lang=js"
export * from "./ChatCommentAttachment.vue?vue&type=script&lang=js"
import style0 from "./ChatCommentAttachment.vue?vue&type=style&index=0&id=14039e54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports